import React from "react";
import {LabeledSection, LabeledValue} from "../../../components/Layout/Page";
import {useTranslation} from "react-i18next";
import {Edit as EditIcon, UploadFile as UploadIcon} from "@mui/icons-material";
import {useModal} from "../../../hooks/useModal";
import {Firmware, FirmwareField} from "../../../app/api/model/firmware";
import FirmwareUploadFileDialog from "./FirmwareUploadFileDialog";
import {useSearchParams} from "react-router-dom";
import {AddEditFirmwareDialog} from "../components/AddEditFirmwareDialog";
import {PermissionLevel} from "../../../app/api/model/user";

interface FirmwareGeneralTabProps {
    firmware: Firmware;
}
const FirmwareGeneralTab = ({firmware}: FirmwareGeneralTabProps) => {
    const {t} = useTranslation();
    const [serachParams] = useSearchParams();
    const editFirmwareModal = useModal(false);
    const uploadFileModal = useModal(serachParams.get("uploadFirmware") === "true");

    const getLabeledValue = (labelKey: string, content: any) => (
        <LabeledValue label={t(labelKey)} content={content} key={labelKey} />
    );
    const metaFields = [
        {
            label: "generic_id",
            content: firmware[FirmwareField.ID],
        },
        {
            label: "firmware_version",
            content: firmware[FirmwareField.VERSION_NUMBER],
        },
        {
            label: "firmware_state",
            content: firmware[FirmwareField.STATE],
        },
        {
            label: "firmware_hardwareType",
            content: firmware[FirmwareField.HARDWARE_TYPE],
        },
        {
            label: "firmware_legacy",
            content: firmware[FirmwareField.LEGACY] ? t("generic_yes") : t("generic_no"),
        },
        {
            label: "firmware_target",
            content: firmware[FirmwareField.TARGET],
        },
    ];

    const fileFields = [
        {
            label: "firmware_s3Key",
            content: firmware[FirmwareField.S3_KEY],
        },
        {
            label: "firmware_checksum",
            content: firmware[FirmwareField.CHECKSUM],
        },
    ];

    return (
        <>
            <LabeledSection
                title={t("generic_firmware")}
                buttons={[
                    {
                        key: "edit",
                        tooltip: "action_editFirmware",
                        disabled: editFirmwareModal.isOpen,
                        minRequiredPermissionToSee: PermissionLevel.MANAGER,
                        callback: () => editFirmwareModal.setIsOpen(true),
                        icon: <EditIcon />,
                    },
                ]}
            >
                {metaFields.map((f) => getLabeledValue(f.label, f.content))}
            </LabeledSection>
            <LabeledSection
                title={t("generic_file")}
                buttons={[
                    {
                        key: "upload",
                        tooltip: "action_upload",
                        disabled: uploadFileModal.isOpen,
                        minRequiredPermissionToSee: PermissionLevel.MANAGER,
                        callback: () => uploadFileModal.setIsOpen(true),
                        icon: <UploadIcon />,
                    },
                ]}
            >
                {fileFields.map((f) => getLabeledValue(f.label, f.content))}
            </LabeledSection>
            <AddEditFirmwareDialog modal={editFirmwareModal} firmware={firmware} />
            <FirmwareUploadFileDialog firmwareId={firmware.id} modal={uploadFileModal} />
        </>
    );
};

export default FirmwareGeneralTab;
